<div class="build-spec-models-details h-100 d-flex flex-column">
  <!-- <div class="d-flex align-items-center gap-2 mb-3">
    <a class="text-decoration-none" (click)="onClose()" role="button">
      <i class="bi bi-arrow-left"></i>
      Back
    </a>
  </div> -->

  <div class="flex-fill">
    <p-tabs [value]="activeTabIndex()" (valueChange)="onTabChange($event)" class="h-100">
      <p-tablist>
        <p-tab [value]="0">
          <i class="bi bi-boxes"></i>
          Model & Elevation</p-tab
        >
        <p-tab [value]="1">
          <i class="bi bi-sliders2"></i>
          Options</p-tab
        >
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel [value]="0">
          <app-model-elevation-tab
            [specLot]="specLot()"
            [isActive]="activeTabIndex() === 0"
            (modelSelected)="onModelSelected($event)"
            (elevationSelected)="onElevationSelected($event)"
          ></app-model-elevation-tab>
        </p-tabpanel>
        <p-tabpanel [value]="1">
          @if (selectedModelId() && selectedElevationId()) {
            <app-options-tab
              [lotId]="specLot().id"
              [modelId]="selectedModelId()!"
              [elevationId]="selectedElevationId()!"
            ></app-options-tab>
          }
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</div>
